import { Mail } from "lucide-react";
import type { ModuleSpec } from "../types";

export const emailDomainsSpec: ModuleSpec = {
  id: "email-domains",
  icon: Mail,
  i18n: {
    namespace: "modules",
    titleKey: "email-domains.title",
    descriptionKey: "email-domains.description",
  },
  nav: {
    path: "/email/domains",
    group: "connect",
    order: 15,
  },
  meta: {
    status: "active",
    description: "Manage email sending domains and senders",
  },
};
